import styled from 'styled-components';

const TableThumbnail = styled.img`
  max-width: 160px;
`;

export default TableThumbnail;
